import { gql } from '@apollo/client';
export const walletFragment = gql `
  fragment walletFields on GetWalletNewPayload {
    amount
    code
    color
    hasNetworks
    iconUrl
    isCrypto
    isDisabled
    isFavorite
    isMemoRequired
    isStable
    name
    networksCount
    percentage
    price: sellRate
    buyRate
    roundingPrecision
    value
  }
`;
//# sourceMappingURL=wallet.js.map